<template>
  <div :class="['layout_container_main_content', {'padding-bottom-20': !isShowFooter}]">
    <header class="flex flex_direction">
      <div class="title_box">
        <h1 class="flex text_size_16 text_bold">{{ title }}</h1>
        <slot name="titleBoxContent"></slot>
      </div>
      <slot name="header"></slot>
    </header>
    <div class="content">
      <slot name="content"></slot>
    </div>
    <footer v-if="isShowFooter" class="flex justify_center align_center">
      <el-pagination
        @current-change="handleCurrentPageNumChange"
        :current-page.sync="pagination.pageNum"
        :page-size="pagination.pageSize"
        layout="prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </footer>
  </div>
</template>
<script>
export default {
  props: {
    // 标题
    title: '',
    // 分页对象
    pagination: {
      type: Object,
      default: () => {
        return {
          // 总条目数
          total: 0,
          // 每一页条目数
          pageSize: 10,
          // 当前页面
          pageNum: 1
        }
      }
    },
    // 是否显示尾部
    isShowFooter: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    // 当前页改变时触发
    handleCurrentPageNumChange (currentPageNum) {
      this.$emit('handleCurrentPageNumChange', currentPageNum)
    }
  }
}
</script>
<style lang="scss" scoped>
  .layout_container_main_content {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    padding-left: 20px;
    padding-right: 20px;
    border-radius:2px;
    overflow: auto;
    & > header {
      .title_box {
        display: flex;
        align-items: center;
        height: 50px;
        margin-bottom: 10px;
        & > h1 {
        }
      }
    }
    .content {
      flex: 1;
      overflow: auto;
    }
    & > footer {
      height: 68px;
      // border-top: 1px solid $border-color-base;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/container/main/main-content.vue